export enum QUERY_OUTPUT {
  JSON = "JSON",
  JSON_COMPACT = "JSON_Compact",
  JSON_COMPACT_LIMITED = "JSON_CompactLimited",
  JSON_LINES = "JSONLines_Compact",
}
